<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/ptSession/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(date)="data">
            {{parseDate(data.item.created_at)}}
          </template>
          <template v-slot:cell(time)="data">
            {{parseTime(data.item.created_at)}}
          </template>
          <template v-slot:cell(actions)="data">
            <b-button v-if="getRoleId != '33'" size="sm" @click="editForm('/ptSession/edit?id=' + data.item.id)" class="btn-table warning mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId == '1'" size="sm" @click="openRulesModal(data.item)" class="btn-table dark mr-1">
              <i class="fas fa-cog"></i> Rules
            </b-button>
          </template>
          <template v-slot:cell(status)="data">
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>

    <!-- Modal Rules -->
    <b-modal ref="rulesModal" :title="'Rules — ' + selectedPtSession.name" size="lg" hide-footer>
      <div class="mb-15">
        <b-table :items="rulesItems" :fields="rulesFields" :hover="true" :striped="true" responsive="sm" show-empty empty-text="Belum ada rules untuk paket ini">
          <template v-slot:cell(is_active)="data">
            <b-badge :variant="data.item.is_active == 1 ? 'success' : 'danger'">
              {{ data.item.is_active == 1 ? 'Active' : 'Inactive' }}
            </b-badge>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button size="sm" @click="toggleActive(data.item)" :class="data.item.is_active == 1 ? 'btn-table warning mr-1' : 'btn-table success mr-1'">
              {{ data.item.is_active == 1 ? 'Deactivate' : 'Activate' }}
            </b-button>
            <b-button size="sm" @click="deleteRule(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
      </div>

      <hr>
      <div class="font-14 font-600 mb-10">Tambah Rule</div>
      <b-row class="mb-10">
        <b-col sm="3"><label class="mt-5">PT Session</label></b-col>
        <b-col sm="9">
          <b-form-input :value="selectedPtSession.name" disabled></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mb-10">
        <b-col sm="3"><label class="mt-5">Rule Type</label></b-col>
        <b-col sm="9">
          <b-form-select v-model="newRule.rule_type" :options="ruleTypeOptions"></b-form-select>
        </b-col>
      </b-row>
      <b-row class="mb-15">
        <b-col sm="3"><label class="mt-5">Status</label></b-col>
        <b-col sm="9">
          <b-form-select v-model="newRule.is_active" :options="[{value: 1, text: 'Active'}, {value: 0, text: 'Inactive'}]"></b-form-select>
        </b-col>
      </b-row>
      <b-button class="btn-primary" @click="submitRule()">
        <i class="fas fa-save mr-5"></i>Save Rule
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'ptSession',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: { type: Boolean, default: true },
    striped: { type: Boolean, default: true },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data: () => {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        {
          key: 'pt_tier',
          label: 'PT Tier',
          formatter: (value) => value == 5 ? 'Tier 1 New' : value,
          sortable: true
        },
        { key: 'price', label: 'Price', sortable: true },
        { key: 'quantity', label: 'Quantity', sortable: true },
        { key: 'expired_in_days', label: 'Expired in Days', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      getId: Auth.Session.get().paradigm_id,
      getRoleId: Auth.Session.get().paradigm_role,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,

      // Rules modal
      selectedPtSession: { id: null, name: '' },
      rulesItems: [],
      rulesFields: [
        { key: 'rule_type', label: 'Rule Type' },
        { key: 'is_active', label: 'Status' },
        { key: 'actions', label: 'Actions' }
      ],
      newRule: {
        rule_type: 'exclude_diary_check',
        is_active: 1
      },
      ruleTypeOptions: [
        { value: 'exclude_diary_check', text: 'Exclude Diary Check' }
      ]
    }
  },
  methods: {
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      this.sortType = event.sortDesc === false ? 'asc' : 'desc'
      this.fetchData()
    },
    enterClicked () {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' || status === 'active' ? 'success'
        : status === 'Inactive' || status === 'inactive' ? 'danger' : 'primary'
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    openRulesModal (ptSession) {
      this.selectedPtSession = { id: ptSession.id, name: ptSession.name }
      this.newRule = { rule_type: 'exclude_diary_check', is_active: 1 }
      this.fetchRules(ptSession.id)
      this.$refs.rulesModal.show()
    },
    fetchRules (ptSessionId) {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/global_rules/pt_session?entity_id=' + ptSessionId).then(response => {
        this.rulesItems = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    submitRule () {
      if (!this.newRule.rule_type) {
        this.$swal('Error', 'Rule Type wajib diisi', 'error')
        return
      }
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.post('crm/v1/global_rules/pt_session', {
        entity_id: this.selectedPtSession.id,
        rule_type: this.newRule.rule_type,
        is_active: this.newRule.is_active,
        created_by: Auth.Session.get().paradigm_id,
        updated_by: Auth.Session.get().paradigm_id
      }).then(() => {
        this.$swal('Success', 'Rule berhasil ditambahkan', 'success')
        this.fetchRules(this.selectedPtSession.id)
      }).catch(error => {
        console.log('error', error)
        this.$swal('Error', 'Gagal menambahkan rule', 'error')
      })
    },
    toggleActive (item) {
      const newStatus = item.is_active == 1 ? 0 : 1
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.put('crm/v1/global_rules/' + item.id, {
        is_active: newStatus,
        updated_by: Auth.Session.get().paradigm_id
      }).then(() => {
        item.is_active = newStatus
      }).catch(error => {
        console.log('error', error)
        this.$swal('Error', 'Gagal mengubah status', 'error')
      })
    },
    deleteRule (id) {
      this.$swal({
        title: 'Hapus rule ini?',
        text: 'Tindakan ini tidak bisa dibatalkan',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, Hapus!',
        cancelButtonText: 'Batal'
      }).then(result => {
        if (result.value) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/global_rules/' + id).then(() => {
            this.fetchRules(this.selectedPtSession.id)
          }).catch(error => {
            console.log('error', error)
            this.$swal('Error', 'Gagal menghapus rule', 'error')
          })
        }
      })
    },
    fetchData () {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/pt_session?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
